<template>
    <div class="modal-with-logo">
        <img class="modal-with-logo__logo"
            src="@/assets/ak-logo-badge--solid-dark.svg" />
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'BaseModalWithLogo',
}
</script>

<style lang="scss" scoped>
.modal-with-logo {
    background-color: white;
    display: flex;
    height: 100%;
    width: 100%;
    border-radius: 13px;
    overflow: hidden;
    position: relative;

    &::before {
        content: '';
        display: block;
        position: absolute;
        background-color: $rfx-brightest-turquoise;
        top: -70px;
        right: -125px;
        width: 385px;
        height: 150px;
        background-color: #54cec3;
        opacity: 0.15;
        transform: rotate(30deg);
        z-index: 10;
    }

    &__logo {
        position: absolute;
        top: 28px;
        right: 28px;
        width: 40px;
        height: 40px;
        z-index: 20;
    }
}
</style>